/**
 * CONSENTIMIENTO DE COOKIES - reescrito 17-09-2026 (Fase 2.2).
 *
 * CORRECCION DE UN DIAGNOSTICO ANTERIOR EQUIVOCADO (Fase 2.1)
 * -----------------------------------------------------------
 * Se concluyo que la tienda no persistia el consentimiento. ERA FALSO. Se midio con dos
 * senales invalidas: (1) buscar _tracking_consent en document.cookie -- Shopify no guarda
 * la decision en una cookie legible por JS, viaja dentro de _shopify_essential (HttpOnly);
 * (2) usar shouldShowBanner() como "ya ha contestado?" -- la doc de Shopify dice que ese
 * metodo NO indica si ya se dio el consentimiento, solo si la region exige banner, y en
 * Espana es true de forma permanente, tambien despues de aceptar.
 *
 * MEDICIONES 17-09-2026. Contexto virgen: getTrackingConsent() "no_interaction";
 * tras setTrackingConsent -> "yes"; tras navegar a otra pagina -> sigue "yes"; tras
 * rechazar -> "no" y marketingAllowed() false; parcial (analytics si / marketing no) se
 * conserva exacto tras recargar. IP espanola: region ESVC, GDPR, enforced true,
 * getTrackingConsent() "yes" con shouldShowBanner() TODAVIA true. Admin API:
 * consentPolicy(ES).consentRequired = true (politica propia 1094920733017, no la SD-).
 *
 * CONCLUSION: la persistencia de Shopify funciona. El fallo estaba en la pregunta.
 * FUENTE DE VERDAD UNICA: getTrackingConsent(). "no_interaction" = preguntar.
 * Cualquier otro valor = ya contesto. Ya no se usa localStorage: alma_cc_v1 se borra.
 *
 * BANNER PROPIO DE SHOPIFY: esta tienda lo tiene ACTIVADO (#shopify-pc__banner, medido
 * en contexto virgen sobre este tema: 1280x198, visible, con aceptar/rechazar/preferencias).
 * No se puede leer ni apagar desde la Admin API (privacySettings exige el scope
 * read_privacy_settings, denegado; no existe mutacion para el banner). Solo a mano en
 * Ajustes > Privacidad del cliente. Para no mostrar DOS banners, esta barra CEDE: si el de
 * Shopify esta presente, la nuestra no se muestra. Si Juan lo apaga, la nuestra aparece
 * sola sin tocar codigo.
 *
 * DEFECTO PREEXISTENTE DEL TEMA (no lo causa esta fase; pasa igual en el tema publicado):
 * el modulo @theme/component no resuelve, asi que <dialog-component> NUNCA se registra y
 * su boton de cerrar (on:click="/closeDialog") esta muerto. Por eso aqui abrimos y
 * cerramos el <dialog> nativo a mano y cableamos la X nosotros. Verificado: showModal() y
 * close() funcionan en el navegador real.
 */

var ALMA_LEGACY_KEY = 'alma_cc_v1';

function almaDropLegacyKey() {
  try { window.localStorage.removeItem(ALMA_LEGACY_KEY); } catch (e) {}
}

function shopifyOwnBanner() {
  return document.getElementById('shopify-pc__banner');
}

function initCookieBanner() {
  almaDropLegacyKey();

  var bar = document.getElementById('cookie-consent-bar');
  var dialog = document.getElementById('cookie-preferences-dialog');
  if (!bar || !window.Shopify || !window.Shopify.customerPrivacy) return;

  var api = window.Shopify.customerPrivacy;
  var acceptButton = document.getElementById('cookie-consent-accept');
  var rejectButton = document.getElementById('cookie-consent-reject');
  var manageButton = document.getElementById('cookie-consent-manage');
  var saveButton = document.getElementById('cookie-consent-save');
  var closeButton = dialog ? dialog.querySelector('.ckd__x') : null;
  var analyticsToggle = document.getElementById('cookie-consent-analytics-toggle');
  var marketingToggle = document.getElementById('cookie-consent-marketing-toggle');
  var reopenLink = document.querySelector('a[href="#cookie-preferences"]');

  function answered() {
    try { return api.getTrackingConsent() !== 'no_interaction'; } catch (e) { return false; }
  }

  function regionAsks() {
    try { return api.shouldShowBanner(); } catch (e) { return false; }
  }

  function openDialog() {
    if (!dialog) return;
    var consent = api.currentVisitorConsent ? api.currentVisitorConsent() : {};
    if (analyticsToggle) analyticsToggle.checked = consent.analytics === 'yes';
    if (marketingToggle) marketingToggle.checked = consent.marketing === 'yes';
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  }

  function closeDialog() {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  bar.hidden = !(regionAsks() && !answered() && !shopifyOwnBanner());

  // El banner de Shopify se inyecta de forma asincrona. Si aparece despues, cedemos.
  if (!bar.hidden && window.MutationObserver) {
    var obs = new MutationObserver(function () {
      if (shopifyOwnBanner()) { bar.hidden = true; obs.disconnect(); }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 8000);
  }

  function decide(analytics, marketing) {
    api.setTrackingConsent(
      { analytics: analytics, marketing: marketing, preferences: analytics, sale_of_data: false },
      function () {}
    );
    bar.hidden = true;
  }

  if (acceptButton) acceptButton.addEventListener('click', function () { decide(true, true); });
  if (rejectButton) rejectButton.addEventListener('click', function () { decide(false, false); });
  if (manageButton) manageButton.addEventListener('click', openDialog);
  if (closeButton) closeButton.addEventListener('click', closeDialog);

  // El enlace del pie permite reabrir preferencias aunque ya se haya contestado.
  if (reopenLink) reopenLink.addEventListener('click', function (event) {
    event.preventDefault();
    openDialog();
  });

  if (saveButton) saveButton.addEventListener('click', function () {
    decide(!!(analyticsToggle && analyticsToggle.checked), !!(marketingToggle && marketingToggle.checked));
    closeDialog();
  });
}

window.Shopify = window.Shopify || {};

if (window.Shopify.customerPrivacy) {
  initCookieBanner();
} else if (window.Shopify.loadFeatures) {
  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
    if (error) return;
    initCookieBanner();
  });
}
